/* eslint-disable @typescript-eslint/no-explicit-any */
import { APIModel } from './api-model.model'

export class APIProductKeyword extends APIModel {
    productKeywordId: number;
    productKeyword: string;
    productKeywordType: string;
    productId: any;
    productKeywordEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        productKeywordId: number;
        productKeyword: string;
        productKeywordType: string;
        productId: any;
        productKeywordEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.productKeywordId = params.productKeywordId
        this.productKeyword = params.productKeyword
        this.productKeywordType = params.productKeywordType
        this.productId = params.productId
        this.productKeywordEnabled = params.productKeywordEnabled ? 1 : 0
    }
}
